import type { Trade } from '../types';

interface TradeTableProps {
  trades: Trade[];
}

export default function TradeTable({ trades }: TradeTableProps) {
  if (trades.length === 0) {
    return <p className="text-trader-muted text-sm py-4">No trades yet</p>;
  }

  return (
    <div className="overflow-x-auto">
      <table className="w-full text-sm">
        <thead>
          <tr className="border-b border-trader-border text-trader-muted text-xs uppercase">
            <th className="text-left py-2 px-3">Time</th>
            <th className="text-left py-2 px-3">Strategy</th>
            <th className="text-left py-2 px-3">Side</th>
            <th className="text-right py-2 px-3">Price</th>
            <th className="text-right py-2 px-3">Size</th>
            <th className="text-right py-2 px-3">Fee</th>
            <th className="text-right py-2 px-3">PnL</th>
            <th className="text-left py-2 px-3">Status</th>
          </tr>
        </thead>
        <tbody>
          {trades.map((t) => (
            <tr key={t.id} className="border-b border-trader-border/50 hover:bg-white/5">
              <td className="py-2 px-3 text-trader-muted">{t.timestamp}</td>
              <td className="py-2 px-3">
                <span className="px-2 py-0.5 rounded text-xs bg-trader-info/20 text-trader-info">
                  {t.strategy}
                </span>
              </td>
              <td className="py-2 px-3">
                <span className={t.side === 'buy' ? 'text-trader-profit' : 'text-trader-loss'}>
                  {t.side.toUpperCase()}
                </span>
              </td>
              <td className="py-2 px-3 text-right font-mono">{t.price.toFixed(4)}</td>
              <td className="py-2 px-3 text-right font-mono">{t.size.toFixed(4)}</td>
              <td className="py-2 px-3 text-right font-mono text-trader-warn">{t.fee.toFixed(4)}</td>
              <td className={`py-2 px-3 text-right font-mono ${t.pnl >= 0 ? 'text-trader-profit' : 'text-trader-loss'}`}>
                {t.pnl >= 0 ? '+' : ''}{t.pnl.toFixed(4)}
              </td>
              <td className="py-2 px-3">
                <span className={`text-xs ${t.status === 'filled' ? 'text-trader-profit' : 'text-trader-muted'}`}>
                  {t.status}
                </span>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
